<template>
  <div id="app">
    <!-- <JsonLD /> -->
    <!-- <HeaderView /> -->
    <router-view />
    <FooterView />
  </div>
</template>

<script>
// import HeaderView from '@/components/HeaderView.vue'
// import JsonLD from '@/components/JsonLD.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: 'IndexView',
  components: {
    // HeaderView,
    FooterView,
    // JsonLD,
  },
}
</script>


<style>
  @import url(./assets/css/font.css);
  @import url(./assets/css/styling.css);
  @import url(./assets/css/ibm-mono.css);
  
</style>

